export default __webpack_public_path__ + "static/media/Olympia_9781408315965.a2d07e54.jpg";